import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSubItems, createSubItem, updateSubItem, resetSubItemState } from '../store/subItemSlice';
import SubItemList from '../components/SubItemList';

const SubItemScreen = () => {
  const dispatch = useDispatch();
  const { subItems, success, isLoading, error } = useSelector((state) => state.subItem);

  const [form, setForm] = useState({
    name: '',
    unit: '',
    isveg: false,
    hasnut: false,
    hasmushroom: false,
    hasdairy: false,
    description: '',
    isactive: true,
  });
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    dispatch(fetchSubItems());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      alert(isEditing ? 'SubItem updated!' : 'SubItem created!');
      setForm({
        name: '',
        unit: '',
        isveg: false,
        hasnut: false,
        hasmushroom: false,
        hasdairy: false,
        description: '',
        isactive: true,
      });
      setIsEditing(false);
      setSelectedId(null);
      dispatch(resetSubItemState());
      dispatch(fetchSubItems());
    }
  }, [success, isEditing, dispatch]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === 'checkbox' ? checked : value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEditing && selectedId) {
      dispatch(updateSubItem({ id: selectedId, formData: form }));
    } else {
      dispatch(createSubItem(form));
    }
  };

  const handleEdit = (subItem) => {
    setIsEditing(true);
    setSelectedId(subItem.id);
    setForm({ ...subItem });
  };

  return (
    <div className="space-y-10 px-6 max-w-4xl mx-auto">
      <div className="bg-white p-6 shadow rounded">
        <h2 className="text-xl font-semibold mb-4">{isEditing ? 'Edit SubItem' : 'Create SubItem'}</h2>
        <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
          <input name="name" value={form.name} onChange={handleChange} placeholder="Name" className="border px-4 py-2 rounded" required />
          <input name="unit" value={form.unit} onChange={handleChange} placeholder="Unit" className="border px-4 py-2 rounded" />
          <textarea name="description" value={form.description} onChange={handleChange} placeholder="Description" className="col-span-2 border px-4 py-2 rounded" />
          {[ 'isveg', 'hasnut', 'hasmushroom', 'hasdairy', 'isactive' ].map((flag) => (
            <label key={flag} className="flex items-center space-x-2">
              <input type="checkbox" name={flag} checked={form[flag]} onChange={handleChange} />
              <span>{flag}</span>
            </label>
          ))}
          <button type="submit" disabled={isLoading} className="col-span-2 bg-blue-600 text-white py-2 rounded">
            {isLoading ? 'Saving...' : isEditing ? 'Update' : 'Create'} SubItem
          </button>
        </form>
      </div>

      {/* List */}
      <SubItemList subItems={subItems} onEdit={handleEdit} />

    </div>
  );
};

export default SubItemScreen;